import React from 'react';
import clsx from 'clsx';

import './CompactRangeSlider.css';
import Slider, { SliderProps } from 'components/slider/Slider';

//
// --- Types ---

export interface CompactRangeSliderProps extends SliderProps {}

//
// --- CompactRangeSlider Component ---

const CompactRangeSlider: React.FC<CompactRangeSliderProps> = props => {
  const {
    className,
    'data-testid': dataTestId = 'compact-range-slider',
    value = [0, 100], // similar to MUI min/max defaults
    valueLabelDisplay = 'off',
    valueLabelFormat,
    ...remainingSliderProps
  } = props;

  const [startValue, endValue] = Array.isArray(value) ? value : [];

  return (
    <div className={clsx('compact-range-slider', className)} data-testid={dataTestId}>
      <div
        className="compact-range-slider-value-label compact-range-slider-value-label-start"
        data-testid={`${dataTestId}-start-value`}
      >
        {typeof valueLabelFormat === 'function' ? valueLabelFormat(startValue, 0) : startValue}
      </div>
      <div className="compact-range-slider-input-container">
        <Slider
          className={clsx('compact-range-slider-input', className)}
          data-testid="compact-range-slider-input"
          value={value}
          valueLabelDisplay={valueLabelDisplay}
          valueLabelFormat={valueLabelFormat}
          {...remainingSliderProps}
        />
      </div>
      <div
        className="compact-range-slider-value-label compact-range-slider-value-label-end"
        data-testid={`${dataTestId}-end-value`}
      >
        {typeof valueLabelFormat === 'function' ? valueLabelFormat(endValue, 1) : endValue}
      </div>
    </div>
  );
};

export default CompactRangeSlider;
